import { useEditFunctionals } from '../../hooks/useEditFunctionals';

export const EditFunctionalLvl1 = () => {
	const { getComponent } = useEditFunctionals({ isLvlOne: true });

	return getComponent();
};
